/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, DIC){
	const a = 'is-active';
	const v = 'is-visible';
	const f = 'is-fixed';
	const slideSpeed = '400';
	const lang = location.pathname.split('/')[1];
	let i;

	// 検索部分------------------------------------------------------------------------------------
	const keywordSerach = () => {
		if($('.js-product-keywordSearch-btn').length) {
			const keywordBtn = $('.js-product-keywordSearch-btn');
			const keywordInput = $('input[name="p_keyword"]');
			let keyword;

			keywordBtn.on('click', function(){
				keyword = keywordInput.val();
				location.href = '/'+lang+'/products/search/?p_keyword='+encodeURI(keyword);
			});
		}
	};
	const productSearch = () => {
		if($('.products-search-form').length) {
			var $switch = $('.products-search-toggle-btn');
			var $block = $('.products-search-toggle-block');

			if(!(location.pathname.split('/')[3].replace('index.html',''))) {
				$switch.addClass(a);
				$block.stop().slideDown(slideSpeed).addClass(a);
			}
			$switch.on('click', function(){
				$(this).toggleClass(a);
				$block.stop().slideToggle(slideSpeed).toggleClass(a);
			});

			var $searchForm = $('.products-search-form');
			var $clearBtn = $('.products-search-btn-clear');

			$clearBtn.on('click', function(){
				$searchForm.find('textarea, :text, select').val('').end().find(':checked').prop('checked', false);
			});
		}
	};
	const productSearchResult = () => {
		if($('.products-search').length) {
			// 用途ボタンチェックされているものを表示
			var urlParam = location.search.substring(1);
			if(urlParam) {
				var param = urlParam.split('&');
				var paramArray = [];
				for(i = 0; i < param.length; i++) {
					var paramItem = param[i].split('=');
					paramArray[paramItem[0]] = paramItem[1];
				}
				if(paramArray.p_app_electronics) {
					$('.js-p_app_electronics').addClass(a);
				}
				if(paramArray.p_app_car) {
					$('.js-p_app_car').addClass(a);
				}
				if(paramArray.p_app_packag) {
					$('.js-p_app_packag').addClass(a);
				}
				if(paramArray.p_app_healthcare) {
					$('.js-p_app_healthcare').addClass(a);
				}
				if(paramArray.p_app_color) {
					$('.js-p_app_color').addClass(a);
				}
				if(paramArray.p_app_display) {
					$('.js-p_app_display').addClass(a);
				}
				if(paramArray.p_app_infra) {
					$('.js-p_app_infra').addClass(a);
				}
				if(paramArray.p_app_func_material) {
					$('.js-p_app_func_material').addClass(a);
				}
			}
			// 用途ボタンクリックイベント
			$('.products-search-label-item').on('click', function(){
				let thisName = $(this).data('name');
				$(this).removeClass(a);
				if(!$('.products-search-label .is-active').length) {
					$('.products-search-label').addClass('is-hidden');
				}
				$('input[name="'+thisName+'"]').prop('checked', false).change();
				$('.products-search-form').submit();
			});
			// 用途が一つも選択されていなかったらブロックごと消す
			if(!$('.products-search-label .is-active').length) {
				$('.products-search-label').addClass('is-hidden');
			}
		}
	};
	const bannerAreaHidden = () => {
		if($('.js-banner-area').length) {
			if(!($('.js-banner-area').text().replace(/^\s+/, '').length)) {
				$('.js-banner-area').remove();
			}
		}
	};
	const functionProductsListJs = () => {
		if(document.querySelectorAll('.js-itemlistWrap').length) {
			// タブ切り替え
			let $tab = document.querySelectorAll('.js-tab');
			let $content = document.querySelectorAll('.js-tab-content');
			if ($tab.length) {
				$tab.forEach(ele => {
					ele.addEventListener('click', () => {
						event.preventDefault();
						$tab.forEach(ele2 => { ele2.parentElement.classList.remove('active'); })
						ele.parentElement.classList.add('active');
						$content.forEach(contentEle => {
							contentEle.style.display = "none";
						});
						let target = ele.getAttribute('data-target');
						if (target === 'all') {
							$content.forEach(contentEle => {
								contentEle.style.display = "block";
							});
						} else {
							let $targetContent = document.querySelectorAll('.js-tab-content[data-target="' + target + '"]');
							$targetContent.forEach(contentEle => {
								contentEle.style.display = "block";
							});
						}
					});
				});
			}
			//lang取得
			const langCode = (() => {
				const segments = window.location.pathname.split('/').filter(Boolean);
				return segments[0] || 'ja'; // デフォルト言語
			})();
			// 製品カテゴリリスト表示
			document.querySelectorAll('.js-itemlistWrap').forEach(ele => {
				let itemlistWrapBtn = ele.querySelectorAll('.js-itemlistWrap-button');
				let itemlistWrapLink = ele.querySelector('.js-itemlistWrap-link');
				let itemlistWrapList = ele.querySelector('.js-itemlistWrap-list');
				// 初期表示
				itemlistWrapBtn[0].classList.add('active');
				itemlistWrapLink.querySelector('a').href = itemlistWrapBtn[0].getAttribute('data-href');
				itemlistWrapLink.querySelector('.js-itemlistWrap-link-text').textContent = itemlistWrapBtn[0].textContent;
				itemlistWrapLink.classList.remove('di_none');
				// JSONデータの読み込み（初期表示）
				if(!(itemlistWrapList.classList.contains('js-itemlistWrap-seo'))) {
					let area = '?p_product_headquarters='+ele.getAttribute('data-area');
					let category = '&p_parent_code='+itemlistWrapBtn[0].getAttribute('data-category');					fetch('/' + langCode + '/ajax/products/business/functional_products_category_3.json' + area + category)
					.then(response => response.json())
					.then(json => {
						const rawList = json.rt_bn_functional_products_list;
						const products = rawList.map(item => ({
							product_linkurl: (item.rt_cf_pc_href && item.rt_cf_pc_href.href) || "#",
							product_thumb_image: (item.rt_cf_pc_thumb_image && item.rt_cf_pc_thumb_image.src) || "",
							product_thumb_alt: (item.rt_cf_pc_thumb_image && item.rt_cf_pc_thumb_image.alt) || "",
							product_name: item['cf_pc_func_name_' + langCode] || "",
							product_description: item['cf_pc_short_description_' + langCode] || "",
							cf_pc_parent_code: item.cf_pc_parent_code || "",
							cf_pc_category: item.cf_pc_category || "",
						}));
						updateProductList(products, itemlistWrapList);
					})
					.catch(error => {
						console.error("製品データの読み込みに失敗しました:", error);
					});
				}
				// ボタンのクリックイベント
				itemlistWrapBtn.forEach(btn => {
					btn.addEventListener('click', () => {
						itemlistWrapBtn.forEach(b => {
							b.classList.remove('active');
							b.style.pointerEvents = 'none';
						});
						btn.classList.add('active');
						itemlistWrapLink.querySelector('a').href = btn.getAttribute('data-href');
						itemlistWrapLink.querySelector('.js-itemlistWrap-link-text').textContent = btn.textContent;
						itemlistWrapList.querySelector('ul').innerHTML = "";
						// JSONデータの読み込み
						let area = '?p_product_headquarters='+ele.getAttribute('data-area');
						let category = '&p_parent_code='+btn.getAttribute('data-category');						fetch('/' + langCode + '/ajax/products/business/functional_products_category_3.json' + area + category)
						.then(response => response.json())
						.then(json => {
							const rawList = json.rt_bn_functional_products_list;
							const products = rawList.map(item => ({
								product_linkurl: (item.rt_cf_pc_href && item.rt_cf_pc_href.href) || "#",
								product_thumb_image: (item.rt_cf_pc_thumb_image && item.rt_cf_pc_thumb_image.src) || "",
								product_thumb_alt: (item.rt_cf_pc_thumb_image && item.rt_cf_pc_thumb_image.alt) || "",
								product_name: item['cf_pc_func_name_' + langCode] || "",
								product_description: item['cf_pc_short_description_' + langCode] || "",
								cf_pc_parent_code: item.cf_pc_parent_code || "",
								cf_pc_category: item.cf_pc_category || "",
							}));
							updateProductList(products, itemlistWrapList);
							itemlistWrapBtn.forEach(b => {
								b.style.pointerEvents = 'auto';
							});
						})
						.catch(error => {
							console.error("製品データの読み込みに失敗しました:", error);
						});
					});
				});
			});
			// 製品リストを更新する関数
			function updateProductList(products, listElement) {
				listElement.querySelector('ul').innerHTML = "";
				if (products.length === 0) {
					const noDataItem = document.createElement("li");
					noDataItem.classList.add("no-data");
					noDataItem.textContent = "";  //該当製品がなかった場合
					listElement.querySelector('ul').appendChild(noDataItem);
					return;
				}
				products.forEach(product => {
					const productItem = document.createElement("li");
					productItem.classList.add("product-item");					productItem.innerHTML = 
					'<a href="' + product.product_linkurl + '">' +
						'<figure class="product-item-image">' +
						'<img src="' + product.product_thumb_image + '" alt="' + product.product_thumb_alt + '">' +
						'</figure>' +
						'<div class="product-item-body">' +
						'<h2>' + product.product_name + '</h2>' +
						'<p>' + product.product_description + '</p>' +
						'</div>' +
					'</a>';

					listElement.querySelector('ul').appendChild(productItem);
				});
			}
		}
	};
	functionProductsListJs();
	keywordSerach();
	productSearch();
	productSearchResult();
	bannerAreaHidden();
})(window.jQuery, window.DIC);
